/**
 * Created by stholly on 14.09.2015.
 */
import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .service('secondaryTradingService', secondaryTradingService);

    function secondaryTradingService() {
        var preselectedNetworkPoint;
        var BROADCAST_SECONDARY_TRADE_DELETED = 'secondaryTradeDeleted';

        return {
            BROADCAST_SECONDARY_TRADE_DELETED:
                BROADCAST_SECONDARY_TRADE_DELETED,
            getPreselectedNetworkPoint: getPreselectedNetworkPoint,
            setPreselectedNetworkPoint: setPreselectedNetworkPoint
        };

        function getPreselectedNetworkPoint() {
            return preselectedNetworkPoint;
        }

        function setPreselectedNetworkPoint(point) {
            preselectedNetworkPoint = [point];
        }
    }
})();
